<template>
    <v-container fluid pa-0 fill-height>
        <v-col md="12" class="login-image"></v-col>
        <v-dialog
            v-model="showChangePassword"
            scrollable
            persistent
            max-width="490"
        >
            <v-card>
                <v-card-title>
                    <h5 class="pt-5 pb-7">Senha</h5>
                </v-card-title>
                <v-card-text>
                    <v-form v-model="isFormValid">
                        <!-- <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    :append-icon="
                                        showPassword ? 'mdi-eye' : 'mdi-eye-off'
                                    "
                                    :type="showPassword ? 'text' : 'password'"
                                    label="Senha atual"
                                    @click:append="showPassword = !showPassword"
                                    outlined
                                    hide-details="auto"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row> -->
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    :append-icon="
                                        showPassword ? 'mdi-eye' : 'mdi-eye-off'
                                    "
                                    :rules="[rules.required, rules.min]"
                                    :type="showPassword ? 'text' : 'password'"
                                    v-model="valueNewPassword"
                                    label="Nova senha"
                                    @click:append="showPassword = !showPassword"
                                    outlined
                                    loading
                                    hide-details="auto"
                                    required
                                >
                                    <template v-slot:progress>
                                        <v-progress-linear
                                            :value="progress"
                                            :color="color"
                                            absolute
                                            height="7"
                                            class="mt-1"
                                        ></v-progress-linear>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    :append-icon="
                                        showPassword ? 'mdi-eye' : 'mdi-eye-off'
                                    "
                                    :type="showPassword ? 'text' : 'password'"
                                    label="Confirme a senha"
                                    @click:append="showPassword = !showPassword"
                                    outlined
                                    v-model="valueConfPassword"
                                    hide-details="auto"
                                    :rules="[
                                        valueNewPassword == valueConfPassword,
                                    ]"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider class="lg" />
                <v-card-actions class="px-6 py-5">
                    <v-btn
                        large
                        rounded
                        outlined
                        depressed
                        class="px-12 gray"
                        @click="loginBack"
                        :loading="loading"
                        >Voltar ao Login</v-btn
                    >
                    <v-spacer />
                    <v-btn
                        color="primary"
                        large
                        rounded
                        depressed
                        class="px-12"
                        @click="changePassword"
                        :disabled="!isFormValid"
                        :loading="loading"
                        >Alterar senha</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showCongrats" scrollable persistent max-width="490">
            <v-card>
                <v-card-title>
                    <h5 class="pt-5 pb-7">Senha</h5>
                </v-card-title>
                <v-card-text>
                    <v-form v-model="isFormValid">
                        <v-row class="my-12">
                            <v-col cols="12" class="text-center">
                                <v-icon class="mr-3 gray" size="32"
                                    >fal fa-smile-wink</v-icon
                                >
                                <h4 class="mt-5 mb-2">
                                    Sua senha foi alterada com sucesso
                                </h4>
                                <p>Bem-vindo(a) de volta.</p>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider class="lg" />
                <v-card-actions class="px-6 py-5">
                    <v-btn
                        color="primary"
                        large
                        rounded
                        depressed
                        class="px-12 mx-auto"
                        @click="loginBack"
                        >Voltar para o Login</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Routes from "@/router/names.js";

import AuthService from "@/scripts/services/auth.service";

import CommonHelper from "@/scripts/helpers/common.helper";

export default {
    data: () => ({
        authService: new AuthService(),
        showChangePassword: true,
        showCongrats: false,
        isFormValid: false,
        showPassword: false,
        valueNewPassword: "",
        valueConfPassword: "",
        isUser: false,
        rules: {
            required: (value) => !!value || "Campo obrigatório.",
            min: (v) =>
                v.length >= 8 || "Mínimo de 8 caracteres alfanuméricos.",
        },
        hash: "",
        loading: false,
    }),
    mounted() {
        this.hash = this.$route.query.hash;
    },
    computed: {
        progress() {
            return Math.min(100, this.valueNewPassword.length * 12.5);
        },
        color() {
            return ["error", "warning", "success"][
                Math.floor(this.progress / 40)
            ];
        },
    },
    methods: {
        loginBack() {
            if(this.isUser){
                this.$router.push({ name: Routes.web.Login });
            } else {
                 this.$router.push({ name: Routes.web.LoginCouncil });
            }
        },
        changePassword() {
            this.loading = true;
            this.authService
                .changeRecoveredPassword(
                    this.hash,
                    this.valueNewPassword
                )
                .then(this.changePasswordCallback)
                .finally(() => (this.loading = false));
        },
        changePasswordCallback(result) {
            if (result && result.passwordChanged) {
                this.isUser = result.isUser
                this.showCongrats = true;
            } else if (result.Login) {
                this.$router.push({ name: Routes.web.Login });
            } else {
                CommonHelper.swal(
                    "Erro",
                    "Não foi possível alterar a sua senha. Isso pode ocorrer se o e-mail de recuperação de senha já foi utilizado ou se foi enviado há mais de um dia.",
                    "error"
                );
            }
        },
    },
};
</script>

<style lang="scss" scoped>
/* Conteudo da direita */
.login-image {
    width: 100%;
    height: 100%;
    position: relative;
    background: rgb(112, 77, 250);
    background: -moz-linear-gradient(
        297deg,
        rgba(112, 77, 250, 1) 0%,
        rgba(93, 206, 242, 1) 100%
    );
    background: -webkit-linear-gradient(
        297deg,
        rgba(112, 77, 250, 1) 0%,
        rgba(93, 206, 242, 1) 100%
    );
    background: linear-gradient(
        297deg,
        rgba(112, 77, 250, 1) 0%,
        rgba(93, 206, 242, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#704dfa",endColorstr="#5dcef2",GradientType=1);
}

.login-image:after {
    content: "";
    display: block;
    background-image: url(https://images.pexels.com/photos/1684916/pexels-photo-1684916.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260);
    background-size: cover;
    background-position: top right;
    position: absolute;
    opacity: 0.2;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    filter: grayscale(1);
}
</style>
